export default function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/userAgent.js
// module id = ./node_modules/@popperjs/core/lib/utils/userAgent.js
// module chunks = 1